import { Type } from '../interfaces';

import { CRITERIA_ORDERABLE, CRITERIA_SEARCHABLE } from './constants';
import { FieldMetadataOptions } from './interfaces';

export const getFieldsSearchable = (Entity: Type): FieldMetadataOptions[] => Reflect.getMetadata(CRITERIA_SEARCHABLE, Entity) || [];
export const getFieldsOrderable = (Entity: Type): FieldMetadataOptions[] => Reflect.getMetadata(CRITERIA_ORDERABLE, Entity) || [];
